var publicPath = __webpack_public_path__;
                    var symbolUrl = 'svg/icons.svg#microsoft-teams';
                    var viewUrl = 'svg/icons.svg#view-microsoft-teams';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 48 48',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };